<template>
    <div>
        <JsonLd :json="jsonld" />
          <main id="special221223">
        <!-- 特集Specialコンテンツここから-->

          <!-- KV Section ここから -->
          <section id="kv" class="kv">
            <video playsinline autoplay muted loop>
                <source src="../../../assets/luxury_travel/luxury_travel05/video/bg_main.mp4" type="video/mp4">
              </video>
            <div id="kv__black"></div><!-- kv__black -->
          </section><!-- kv -->

          <div class="kv__titleArea">
            <p class="kv__title--sub fadeIn">Luxury Travel</p>
            <h2 class="kv__title fadeIn" id="kv__title">Colors of Tradition:<br> The Red Crafts of Okayama</h2>
            <p class="playVideo fadeIn" @click="openStreaksPlayer('656084183aad4751a54279a8f93a19f0')">
                <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel05/svg/play_icon.svg" alt="">Play video
            </p>
          </div><!-- kv__titleArea -->


          <!-- Lead Section ここから -->
          <section id="lead" class="lead">

            <div class="leadSecion02">
              <div class="leadPhotosArea1">
                <img class="lead__photos01 fadeIn" src="../../../assets/luxury_travel/luxury_travel05/lead01.jpg" alt="">
                <img class="lead__photos02 fadeIn" src="../../../assets/luxury_travel/luxury_travel05/lead02.jpg" alt="">
              </div><!-- leadPhotosArea1 -->

              <div class="lead__des_wrapper2">
                <p class="lead__des2 fadeIn">Traditional arts flourish in Okayama Prefecture, nurtured by its abundant natural resources. Make your own pottery in the ancient production area of Bizen; travel to historic Fukiya village, one of this nation’s lesser-known treasures, to try Bengara dyeing and stroll amid its “Japan Red” tiled roofs.</p>
              </div><!-- lead__des_wrapper2 -->
            </div><!-- leadSecion02 -->

            <div class="lead__largeImage">
              <img src="../../../assets/luxury_travel/luxury_travel05/large_dammy.png" alt="" class="">
            </div><!-- lead__largeImage -->


            <div class="leadSection03">
              <div class="leadPhotosArea2">
                <img class="lead__photos03 fadeIn" src="../../../assets/luxury_travel/luxury_travel05/lead04.jpg" alt="">
                <img class="lead__photos04 fadeIn" src="../../../assets/luxury_travel/luxury_travel05/lead05.jpg" alt="">
              </div><!-- leadPhotosArea2 -->

              <div class="lead__des_wrapper3">
                <p class="lead__des3 fadeIn">Climb to Bitchu Matsuyama Castle, floating above a sea of mountaintop clouds, and visit Japan’s first public school to accept commoners centuries ago. Wherever you go, the caretakers of Okayama’s past will greet you with open friendliness and a passion to share their heritage.</p>
              </div><!-- lead__des_wrapper3 -->
            </div><!-- leadSection03 -->

          </section><!-- lead -->



          <!-- Heritage Section ここから -->
          <section class="heritage" id="heritage">

            <div class="heritage__largeImage">
              <video playsinline autoplay muted loop>
                <source src="../../../assets/luxury_travel/luxury_travel05/video/bg_heritage.mp4" type="video/mp4">
              </video>
              <div id="heritage__largeImage__black"></div><!-- heritage__largeImage__black -->
            </div><!-- heritage__largeImage -->


              <div class="heritage_titleArea">
                <h1 class="heritage_title fadeIn" id="heritage_title">The Power of<br>Japan Red</h1>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('8625e08ba23140a6bfde415b6316ca4d')">
                  <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel05/svg/play_icon.svg" alt="">Play video
                </p>
              </div><!-- heritage_titleArea -->

              <div class="heritageSection01">

                <div class="japanHeritageWrapper">
                  <img src="../../../assets/luxury_travel/luxury_travel05/svg/japan_heritage.svg" class="japanHeritage">
                </div><!-- japanHeritageWrapper -->

                <div class="heritage__des001_wrapper">
                  <p class="heritage__des001 fadeIn">Like a painting come to life, picturesque Fukiya village was once Japan’s top producer of <span class="italic">Bengara</span>, a pigment used for everything from coloring ceramics to protecting ships from corrosion.</p>
                </div><!-- heritage__des001_wrapper -->

              </div><!-- heritageSection01 -->

              <div class="heritageSection02">
                <div class="heritagePhotosArea1">
                  <img class="heritage__photos001 fadeIn" src="../../../assets/luxury_travel/luxury_travel05/heritage01.jpg" alt="">
                </div><!-- heritagePhotosArea1 -->
              </div><!-- heritageSection02 -->

              <div class="heritage__largeImage2">
                <img src="../../../assets/luxury_travel/luxury_travel05/large_dammy.png" alt="">
              </div><!-- heritage__largeImage2 -->

              <div class="heritage__des002_wrapper">
                <p class="heritage__des002 fadeIn">Dubbed “Japan Red,” this soft reddish-brown is all around you in the walls and roof tiles of Fukiya’s historic buildings. Among the attractions here are homes built by former <span class="italic">Bengara</span> magnates and friendly shops where you can dye your own souvenirs.</p>
              </div><!-- heritage__des002_wrapper -->

          </section><!-- heritage -->


          <section class="heritage_horizon">
            <div class="heritage_horizon_inner">

              <div class="photo_wrapper heritage__photos01">
                <img src="../../../assets/luxury_travel/luxury_travel05/heritage03.jpg" alt="" class="heritage__photos01_inner">
              </div><!-- heritage__photos01 -->

              <div class="photo_wrapper heritage__photos02">
                <img src="../../../assets/luxury_travel/luxury_travel05/heritage04.jpg" alt="" class="heritage__photos02_inner">
              </div><!-- heritage__photos02 -->

              <p class="heritage__des1">Okayama Prefecture is also home to Bizen, the oldest of the six ceramic production areas known as Japan’s “ancient kilns.” The artisans of <span class="italic">Bizen yaki</span> pottery use no glaze to adorn their creations, but instead allow the natural beauties of the clay to emerge through firing. Each piece is therefore unique – these works will captivate you with their rich tones and appealing blend of elegance and vitality.</p>


              <p class="heritage__des1_2">You can admire <span class="italic">Bizen yaki</span> throughout this area, and not just in the vases, cups and other items that make such striking souvenirs. Two large lion dogs made of <span class="italic">Bizen yaki</span> greet visitors at the gate of Amatsu Shrine, and many more playful figures can be found inside, including statues depicting the 12 animals of the Chinese zodiac. You can even take home one of the ceramic votive tablets made by the chief priest and his son.</p>

              <div class="photo_wrapper heritage__photos03">
                <img class="heritage__photos03_inner" src="../../../assets/luxury_travel/luxury_travel05/heritage05.jpg" alt="">
              </div><!-- heritage__photos03 -->

              <div class="photo_wrapper heritage__photos04">
                <img class="heritage__photos04_inner" src="../../../assets/luxury_travel/luxury_travel05/heritage06.jpg" alt="">
              </div><!-- heritage__photos04 -->

              <p class="heritage__des2">Be sure to visit the magnificent Lecture Hall – designated as a national treasure – and other structures at the Shizutani School. Founded in 1670, this was Japan’s first public school to accept commoners; to walk amid its centuries-old buildings and vast, tranquil grounds is a profoundly moving experience. Two immense “trees of learning” also stand here, raised from seeds brought from the gravesite of Confucius. Now more than 100 years old, they are especially spectacular in their autumn colors.</p>



              <div class="photo_wrapper heritage__photos05">
                <img class="heritage__photos05_inner" src="../../../assets/luxury_travel/luxury_travel05/heritage07.jpg" alt="">
              </div><!-- heritage__photos05 -->

              <div class="photo_wrapper heritage__photos06">
                <img class="heritage__photos06_inner" src="../../../assets/luxury_travel/luxury_travel05/lead01.jpg" alt="">
              </div><!-- heritage__photos06 -->


              <p class="heritage__des3">Another memorable experience in this area is the chance to see <span class="italic">Bitchu kagura</span>, a Shinto ritual dance dedicated to the gods that has been designated as an important intangible folk-culture asset.</p>




            </div><!-- heritage_horizon_inner -->
          </section><!-- heritage_horizon -->


          <!-- Accommodation Section ここから -->
          <section class="accommodation" id="accommodation">

            <div class="accommodation__largeImage">
              <video playsinline autoplay muted loop>
                <source src="../../../assets/luxury_travel/luxury_travel05/video/bg_accommodation.mp4" type="video/mp4">
              </video>
              <div id="accommodation__largeImage__black"></div><!-- accommodation__largeImage__black -->
            </div><!-- accommodation__largeImage -->



            <div class="accommodation__title_wrapper">
              <h2 class="accommodation__title fadeIn">Rest in a<br>Tranquil Haven<br>from Days Gone By</h2>
              <p class="playVideo fadeIn" @click="openStreaksPlayer('0e90358003ba43faa1bb7102ed57f14e')">
                <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel05/svg/play_icon.svg" alt="">Play video
              </p>
            </div><!-- accommodation__title_wrapper -->


             <img class="accommodation_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel05/svg/accommodation.svg" alt="Accommodation">


             <div class="accomodation_section01">

               <div class="accommodation_photo01 fadeIn">
                 <img class="accommodation__photos01_inner" src="../../../assets/luxury_travel/luxury_travel05/ac01.jpg" alt="">
                 <img class="accommodation__photos02_inner" src="../../../assets/luxury_travel/luxury_travel05/ac02.jpg" alt="">
               </div><!-- accommodation_photo01 -->

               <div class="accommodation__des_wrapper">
                <p class="accommodation__des fadeIn">When it’s time to relax after a day of sightseeing, the Machiya Stay Fukiya Senmai hotel offers a peaceful oasis of quiet and seclusion. Tucked away in a corner of the historic Fukiya village, this two-story property was built as a private home in 1882 and is now rented in its entirety to one group of guests at a time.</p>
                <p class="accommodation__des1_2 fadeIn">Here you will find a soothing blend of traditional Fukiya architecture and modern comfort – luxuriate in a fragrant bath made of <span class="italic">hinoki</span> cypress wood; warm your feet on the heated living room floor as you gaze at the evening stars above the garden. </p>
               </div><!-- accommodation__des_wrapper -->

               </div><!-- accomodation_section01 -->


               <div class="accomodation_section02">

               <div class="accommodation_photo02 fadeIn">
                <img class="accommodation__photos03_inner" src="../../../assets/luxury_travel/luxury_travel05/ac03.jpg" alt="">
                 <img class="accommodation__photos04_inner" src="../../../assets/luxury_travel/luxury_travel05/ac04.jpg" alt="">

               </div><!-- accommodation_photo02 -->

               <div class="accommodation_des02_wrapper">
                <p class="accommodation_des02 fadeIn">The proprietors will essentially leave guests to themselves after check-in, but the their hospitality can be felt throughout the hotel, from the comfortable furniture to the beautiful <span class="italic">ikebana</span> flower arrangement in the parlor. Meals can be ordered from the adjacent café, as well as from nearby restaurants.</p>
                </div><!-- accommodation__des02_wrapper -->

              </div><!-- accomodation_section02 -->


          </section><!-- accommodation -->


          <!-- Cuisine Section  ここから -->
          <section id="cuisine" class="cuisine">

              <div class="cuisine__largeImage">
                <video playsinline autoplay muted loop>
                  <source src="../../../assets/luxury_travel/luxury_travel05/video/bg_cuisine.mp4" type="video/mp4">
                </video>
                <div id="cuisine__largeImage__black"></div><!-- cuisine__largeImage__black -->
              </div><!-- cuisine__largeImage -->

              <img class="cuisine_tag fadeIn" src="../../../assets/luxury_travel/luxury_travel05/svg/cuisine.svg" alt="Cuisine">

              <div class="cuisine__title_wrapper">
                <h2 class="cuisine__title fadeIn">Dine in Cheerful,<br>Elegant Style</h2>
                <p class="playVideo fadeIn" @click="openStreaksPlayer('6ae56d4bec684c4180a61d936f8e370c')">
                  <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel05/svg/play_icon.svg" alt="">Play video
                </p>
              </div><!-- cuisine__title_wrapper -->

              <div class="cuisine_section01">

                <div class="cuisine_photo01 fadeIn">
                   <img src="../../../assets/luxury_travel/luxury_travel05/cuisine01.jpg" alt="">
                   <img src="../../../assets/luxury_travel/luxury_travel05/cuisine02.jpg" alt="">
                 </div><!-- cuisine_photo01 -->

                  <div class="cuisine__des_wrapper">
                  <p class="cuisine__des fadeIn">Thanks to its mild climate and position facing the Seto Inland Sea, Okayama Prefecture boasts many culinary riches. One of the leading examples of this local bounty is <span class="italic">Bizen barazushi</span>, a colorful sushi dish generously topped with seafood and seasonal vegetables. And you must sample Okayama’s succulent fruits as well, including its delicious peaches and Muscat grapes. </p>
                 </div><!-- cuisine__des_wrapper -->

             </div><!-- cuisine_section01 -->


             <div class="cuisine__largeImage2">
                <img src="../../../assets/luxury_travel/luxury_travel05/large_dammy.png" alt="">
              </div><!-- cuisine__largeImage2 -->

             <div class="cuisine_section02">

                 <div class="cuisine__des02_wrapper">
                  <p class="cuisine__des02 fadeIn">One of the finest dining experiences in the prefecture awaits you at the Happou restaurant in Okayama City, where veteran chef Toshiya Hamura has been awarded two Michelin stars for his <span class="italic">kui-kiri ryori</span>. The name of this cuisine refers to the portions served; the literal meaning is “food to eat entirely.” The aim is for diners to finish every bite, and each item is sized accordingly. Chef Hamura also presents his creations without elaborate decoration or artifice – he focuses instead on drawing out the inherent flavors of the ingredients, selected from among the best in Okayama and throughout Japan.</p>
                 </div><!-- cuisine__des02_wrapper -->

             </div><!-- cuisine_section02 -->

             <div class="cuisine_section03">

               <div class="cuisine_photo02 fadeIn">
                  <img src="../../../assets/luxury_travel/luxury_travel05/cuisine04.jpg" alt="">
                  <img src="../../../assets/luxury_travel/luxury_travel05/cuisine05.jpg" alt="">
               </div><!-- cuisine_photo02 -->

               <div class="cuisine__des03_wrapper">
              <p class="cuisine__des03 fadeIn">The atmosphere at Happou is both elegant and cheerful, with many antique and Bizen ceramic dishes chosen by chef Hamura himself. Take a seat at the bright wooden counter to watch your meal be prepared with consummate skill and genial hospitality – feel free to request some of your favorite fare when making a reservation or put the choices entirely in chef Hamura’s hands. Each bite is a wonder; you are sure to finish with your appetite sated and your spirits light.</p>
             </div><!-- cuisine__des03_wrapper -->

            </div><!-- cuisine_section03 -->

          </section><!-- cuisine -->


          <!-- Experience Section ここから -->
          <section id="experience" class="experience">

            <div class="experience__largeImage">
              <video playsinline autoplay muted loop>
                <source src="../../../assets/luxury_travel/luxury_travel05/video/bg_experience.mp4" type="video/mp4">
              </video>
              <div id="experience__largeImage__black"></div><!-- experience__largeImage__black -->
            </div><!-- experience__largeImage -->

            <div class="experience__title_wrapper">
              <h2 class="experience__title fadeIn">Witness<br>Ancient Traditions<br>Brought to Life</h2>
              <p class="playVideo fadeIn" @click="openStreaksPlayer('31eef377c3ef43908a23a12d0b94cf99')">
                <img class="playVideo__icon" src="../../../assets/luxury_travel/luxury_travel05/svg/play_icon.svg" alt="">Play video
              </p>
            </div><!-- experience__title_wrapper -->

            <div class="experienceSection01">
                <div class="experienceTagWrapper">
                  <img src="../../../assets/luxury_travel/luxury_travel05/svg/experience.svg" class="experience_tag">
                </div><!-- experienceTagWrapper -->

                <div class="experience__des001_wrapper">
                  <p class="experience__des001 fadeIn">Blessed with high-quality iron sand as well as the timber needed to fuel its forges, the Bizen area was the leading producer of Japanese swords for hundreds of years, home to more artisans than anywhere else in the country. </p>
                </div><!-- experience__des001_wrapper -->
            </div><!-- experienceSection01 -->



            <!-- Experience Horizon ここから -->
            <section class="experience_horizon">
            <div class="experience_horizon_inner">


              <div class="photo_wrapper experience__photos01">
                <img src="../../../assets/luxury_travel/luxury_travel05/ex01.jpg" alt="" class="experience__photos01_inner">
              </div><!-- experience__photos01 -->

              <div class="photo_wrapper experience__photos02">
                <img src="../../../assets/luxury_travel/luxury_travel05/ex02.jpg" alt="" class="experience__photos02_inner">
              </div><!-- experience__photos02 -->

              <p class="experience__des1">This proud tradition lives on at the Bizen Osafune Token Village, which presents displays of traditional forging work on the second Sunday of every month. Over and over, golden sparks fly wide as artisans remove impurities by striking steel heated to 1,300 degrees Celsius (over 2,300 Fahrenheit). </p>


              <!-- <p class="experience__des2">Mt. Haguro, the smallest of the Dewa Sanzan, provides the easiest challenge of the three peaks. From the pilgrim lodgings below the mountain, a flight of 2,446 stone steps winds upward amidst majestic cedar trees. With your <i>yamabushi</i> guide, you’ll pass ancient shrines and the lofty  five-storey pagoda of Mt. Haguro, before arriving at the shrine complex on the peak, dedicated to the gods of all three of the Dewa Sanzan mountains.</p> -->

              <div class="photo_wrapper experience__photos03">
                <img src="../../../assets/luxury_travel/luxury_travel05/ex03.jpg" alt="" class="experience__photos03_inner">
              </div><!-- experience__photos03 -->

              <p class="experience__des2">Other stages in the creation of these powerful, elegant weapons can also be seen here, including the sharpening and engraving of the blade, as well as displays of swords from Bizen and elsewhere in Japan. The facility provides explanatory materials in English and French, and can arrange for speakers of those languages to guide you. Private demonstrations of the forging process can also be reserved on a day to suit your schedule.</p>

              <div class="photo_wrapper experience__photos04">
                <img src="../../../assets/luxury_travel/luxury_travel05/ex04.jpg" alt="" class="experience__photos04_inner">
              </div><!-- experience__photos04 -->

              <div class="photo_wrapper experience__photos05">
                <img src="../../../assets/luxury_travel/luxury_travel05/ex05.jpg" alt="" class="experience__photos05_inner">
              </div><!-- experience__photos05 -->

              <p class="experience__des4">Bizen is likewise home to many ceramic studios where artisans will help you create your own unique piece. Feeling it take shape in your hands will both invigorate and soothe your spirit – don’t miss this opportunity to fashion a work of elegant natural beauty. <br>You can also get a close-up look at the area’s multi-chambered <i>noborigama</i> climbing kilns.</p>


            </div><!-- experience_horizon_inner -->
          </section><!-- experience_horizon -->

            </section><!-- experience -->


            <div class="maplinkArea">
              <a class="maplink" href="https://www.google.com/maps/d/edit?hl=en&hl=en&mid=1Pree4cCEoeRG-8cl5QVq75ZLIFqcZQI&ll=34.72182168998002%2C134.10707684999994&z=18"  target="_blank">See on map <img src="../../../assets/luxury_travel/luxury_travel05/svg/outerlink.svg"></a>
            </div><!-- maplinkArea -->

              <Questionnaire :page-id="pageId" />

            <!-- See other luxury destinations ここから -->
              <SeeOtherLuxury />
            <!-- See other luxury destinations ここまで -->

            <!-- Nearby Japan Heritage Sites 挿入箇所 -->

            <!-- Other Sites in Same Category 挿入箇所 -->

          <!-- 特集Specialコンテンツここまで-->
          <streaks-player ref="streaks"></streaks-player>
        </main>
    </div>
</template>

<script>
import StreaksPlayer from "@/components/StreaksPlayer/StreaksPlayer";
import ApiRouter from "@/components/Systems/ApiRouter";
import SeeOtherLuxury from "../SeeOtherLuxury";
import "video.js/dist/video-js.css";
import Questionnaire from "../Questionnaire.vue";
import JsonLd from "@/components/JsonLd/JsonLd.vue";

export default {
    name: "LuxuryTravel05",
    components: {JsonLd, Questionnaire, StreaksPlayer, SeeOtherLuxury },
    mixins: [ApiRouter],
    data: function () {
        return {
            publicPath: `${process.env.VUE_APP_PUBLIC_PATH}`,
            pageId: '5',
            jsonld: {
                "@context": "https://schema.org",
                "@type": "Article",
                "mainEntityOfPage": window.location.href,
                "headline": "Colors of tradition: The red crafts of Okayama",
                "description": "Japan Heritage ties together historical sites, shrines, temples, traditional arts, castles, armor," +
                    "and other cultural assets. Find photos, videos, tourist information, and more.",
                "image": [
                    require('../../../assets/luxury_travel/index/luxury05.jpg')
                ],
                "datePublished": "2022/12/23",
                "dateModified": "2023/12/19",
                "author": [{
                    "@type": "Organization",
                    "name": "Japan National Tourism Organization",
                    "url": "https://www.japan.travel/japan-heritage/"
                }]
            }
        };
    },
    mounted: function () {
        document.title = 'Japan Heritage Official Site | Stories and travel information | JNTO'
        let url = this.publicPath + "js/luxurytravel/luxurytravel05.js";
        let recaptchaScript = document.createElement("script");
        recaptchaScript.setAttribute("src", url);
        document.head.appendChild(recaptchaScript);
    },
    methods: {
        openStreaksPlayer: function (id) {
            this.$refs.streaks.open(id);
        },
    },
};
</script>

<style src="./LuxuryTravel05.scss" lang="scss" scoped/>
